export default "__VITE_ASSET__pPyxfeCj__"